import { render } from "./query_List.vue?vue&type=template&id=6bd64a6c"
import script from "./query_List.vue?vue&type=script&lang=js"
export * from "./query_List.vue?vue&type=script&lang=js"

import "./query_List.vue?vue&type=style&index=0&id=6bd64a6c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__